import {
  roles,
} from "@/Enums"

import type {
  AuthorizedActions,
} from "@/authorization";

const reportPolicies: AuthorizedActions = {
  read: [roles.Hauptbenutzer, roles.BenutzerFinanz],
  edit: [roles.Hauptbenutzer],
  download: [roles.Hauptbenutzer, roles.BenutzerFinanz]
}

export {
  reportPolicies
}
